import React from 'react'
import ViewEditEventManagementList from '../../features/EventManagement/ViewEditEventManagementList'

const ViewEditEventManagement = () => {
    return (
       <>
       <ViewEditEventManagementList/>
       </>
    )
}

export default ViewEditEventManagement